import { gsap } from 'gsap';
function Animate(
  sprite,
  {
    duration = 1,
    speed = 1,
    ease = 'power3.in',
    type,
    elementToAnimate,
    delayValue,
    direction,
    SubSceneContainer,
    Textsprite,
    isMask,
    TextBackgroundSprite,
  }
) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  let xCoord = sprite.x;
  let yCoord = sprite.y;
  let elementHeight = sprite.height;
  let elementWidth = sprite.width;

  var animX;
  var animY;
  switch (direction) {
    case 'up':
      animX = 0;
      animY = sprite.height;
      break;
    case 'down':
      animX = 0;
      animY = -sprite.height;
      break;
    case 'left':
      animX = sprite.width;
      animY = 0;
      break;
    case 'right':
      animX = -sprite.width;
      animY = 0;
      break;
  }

  if (type == 'entry') {
    if (isMask) {
      SubSceneContainer.addChild(sprite);
      Textsprite.mask = sprite;
      TextBackgroundSprite.mask = sprite;
      animation = gsap.from(sprite, {
        pixi: {
          x: sprite.x + animX,
          y: sprite.y + animY,
        },
        duration: speed,
        ease: 'power3.out',
        onComplete: () => {
          Textsprite.mask = undefined;
          TextBackgroundSprite.mask = undefined;
          SubSceneContainer.removeChild(sprite);
        },
        //stagger: duration / steps,
      });
    }
  } else {
    if (isMask) {
      //SubSceneContainer.addChild(sprite);
      //Textsprite.mask = sprite;
      //TextBackgroundSprite.mask = sprite;
      animation = gsap.to(sprite, {
        pixi: {
          x: sprite.x + animX,
          y: sprite.y + animY,
        },
        duration: speed,
        delay: steps > 1 ? delayValue - duration : delayValue,
        ease: 'power3.in',
        onStart: () => {
          SubSceneContainer.addChild(sprite);
          Textsprite.mask = sprite;
          TextBackgroundSprite.mask = sprite;
        },
        //stagger: duration / steps,
      });
    }
  }
  return animation;
}
export default { Animate };
